//BG: Style the output from the Ajax request 
function outputColourSwatchProducts(json, currentProductID) {

    
    // var listMarkup = '<ul class="product-colours">',
    var listMarkup = '<select class="product-colours" onchange="location = this.value;" style="text-transform: capitalize;">',
        productColourContainer = $('.product-colours-container');
  
    //for each product
    for (var key in json.products) {
        var productColour = json.products[key]['colour'],
            productURL = json.products[key]['url'],
            productID = json.products[key]['id'],
            activeClass = "",
            selected = "";

            var pathArray = productURL.split('/');
            var secondLevelLocation = pathArray[4];
            var str = secondLevelLocation.replace(/-/g, ' ').toLowerCase();
  
        //if current product ID matches the product ID in the loop, set active class and selected option.    
        if (productID === currentProductID) {
            activeClass = " current";
            selected = ' selected="selected"';
        }
  
        //Add option product to the list and select markup
        //listMarkup += '<li class="'+activeClass+'"><a href="'+productURL+'" class="'+'pdp__colour__' + productColour.toLowerCase()+'">'+productColour+'</a></li>';
        listMarkup += '<option value="' + productURL +'" '+selected+'>'+str+'</option>';
    }
  
    //close list and select markup
    //listMarkup += '</ul>';
    listMarkup += '</select>';
  
    //output the results.
    productColourContainer.append(listMarkup);
    productColourContainer.removeClass('d-none');
  
  }
  
  function getMatchingProductsByTag() {
    /* only run if this div exists. This won't appear if: 
    A) the snippet 'product-colour-swatch.liquid' file is not included on the product page 
    B) the product does not have a tag that contains "group_colours_"
    */
    

    if ($('.product-colours-container').length) {

        var colourGroupName = $('.product-colours-container').attr('data-colour-group'),
            currentProductID = $('.product-colours-container').attr('data-current-product-id'),
            currentCollection = $('.product-colours-container').attr('data-current-collection-handle');
  
            //Check to see if the current product is within a collection. if it's not default to 'all'
            //UPDATE: not all the colour variants sit within the same collection.
            if (!currentCollection) {
                currentCollection = 'all'
            }
  
        $.ajax({
            type: 'GET',
            //BG: "?view=colour" is a url parameter that will the template based on the value provided.
            // colourGroupName applies a Shopify filter that finds products based on product tag.
            url: '/collections/'+currentCollection+'/' + colourGroupName + '?view=colour',
            success: function (data) {
                if(data) {
                    try {
                        var json = JSON.parse(data);
                    } catch(e) {
                        var json = null; // meh
                    }
                }
                //if Json is sucessful, pass over to function to output the results.
                if (json) {
                    outputColourSwatchProducts(json,currentProductID);
                }
            }
        });
    }
  }

  if ($('body.template-product').length) {
    getMatchingProductsByTag();
  }